import React, { useEffect, useRef, useState } from "react";
import Loaders from "../Loaders";
import HeaderTop from "../HeaderTop";
import Menus from "../Menus";
import Footers from "../Footers";
import "../../../libs/css/bootstrap.min3.3.7.css";
import "../../../libs/css/sweetalert2.min.css";
import { API_ROUTES } from "../../../utils/constants";
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner";
import DataTable from "react-data-table-component";
import Swal from "sweetalert2";
import FilterComponent from "./FilterComponent";
import { format } from "date-fns";

export default function SubscriberCounts(props) {
  const {
    objectToFormData,
    Helmet,
    capitalizeWords,
    isAuthExpired,
    allCPs,
    isLoading1,
    userSessions,
  } = props;

  useEffect(() => {
    document.title = "Subscriber Counts | Forthsoft";
  }, []);

  const [isLoading, setIsLoading] = useState(false);
  const [dataList, setDataList] = useState([]);
  const [isFade, setIsFade] = useState(false);
  const [currentFilters, setCurrentFilters] = useState(null);
  const [responseType, setResponseType] = useState("");

  const filterRef = useRef(null);

  const networkData = [
    { id: "1", name: "MTN" },
    { id: "2", name: "GLO" },
    { id: "3", name: "AIRTEL" },
    { id: "4", name: "9MOBILE" },
  ];

  const userData = JSON.parse(localStorage.getItem("userDataFs"));

  const columns = [
    {
      name: "Period",
      selector: (row) => row.period,
      sortable: true,
      cell: (row) => <div>{row.period}</div>,
      // width: "260px",
    },
    {
      name: "Count",
      selector: (row) => Number(row.count || 0).toLocaleString(),
      sortable: true,
    },
  ];

  const getData = async (dataString) => {
    setIsFade(true);
    setIsLoading(true);

    try {
      const response = await fetch(API_ROUTES.SUBSCRIBER_COUNTS, {
        method: "POST",
        body: objectToFormData(dataString),
        headers: { token: userData?.responseDetails?.token },
      });
      const responseJSON = await response.json();
      isAuthExpired(responseJSON);

      if (responseJSON.status.toString() === "200") {
        setDataList(responseJSON.data || []);
        setResponseType(responseJSON.type || dataString.type);
        setCurrentFilters(dataString);
        setIsLoading(false);
        setIsFade(false);
        filterRef.current?.resetService();
      } else {
        setDataList([]);
        setResponseType("");
        setCurrentFilters(null);
        setIsLoading(false);
        setIsFade(false);
        filterRef.current?.resetService();

        Swal.fire({
          title: "No Data",
          text:
            responseJSON.message || "No data found for the selected criteria",
          icon: "info",
        });
      }
    } catch (error) {
      console.log("Error getting data: ", error);
      setDataList([]);
      setResponseType("");
      setCurrentFilters(null);
      setIsLoading(false);
      setIsFade(false);
      filterRef.current?.resetService();

      Swal.fire({
        title: "Error",
        text: "Failed to fetch data. Please try again.",
        icon: "error",
      });
    }
  };

  const handleDuration = (data) => {
    if (!data.cp_id) {
      Swal.fire({ title: "Error", text: "Please select a CP", icon: "error" });
      return;
    }
    if (!data.network_id) {
      Swal.fire({
        title: "Error",
        text: "Please select a network",
        icon: "error",
      });
      return;
    }

    const dataString = {
      cp_id: data.cp_id,
      network_id: data.network_id,
      fro: data.fro + " 00:00:00",
      to: data.to + " 23:59:59",
      type: data.type,
    };

    if (data.serviceId) {
      dataString.serviceId = data.serviceId;
    }

    getData(dataString);
  };

  const totalCount = dataList.reduce(
    (sum, row) => sum + Number(row.count || 0),
    0,
  );

  const exportToCSV = () => {
    if (!dataList.length) {
      Swal.fire({
        title: "No Data",
        text: "Please filter data first before exporting",
        icon: "warning",
      });
      return;
    }

    let csvContent = "Period,Count\n";

    dataList.forEach((row) => {
      csvContent += `"${row.period}","${Number(row.count || 0).toLocaleString()}"\n`;
    });

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    const url = URL.createObjectURL(blob);
    link.setAttribute("href", url);
    link.setAttribute(
      "download",
      `subscriber_counts_${responseType}_${format(new Date(), "yyyyMMdd_HHmmss")}.csv`,
    );
    link.style.visibility = "hidden";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const typeBadgeColor = {
    daily: "#0d6efd",
    weekly: "#6610f2",
    monthly: "#198754",
  };

  return (
    <>
      <div className="flapt-page-wrapper mainContent">
        <Menus />

        <div className="flapt-page-content">
          <HeaderTop />

          <div className="main-content introduction-farm mt--20">
            <div className="content-wraper-area">
              <div className="dashboard-area">
                <div className="container-fluid mb-90">
                  <div className="card-header mb--30 mb-xs-10 ml-10">
                    <h2>Subscriber Counts</h2>
                  </div>

                  {isLoading1 ? (
                    <LoadingSpinner />
                  ) : (
                    <>
                      <FilterComponent
                        ref={filterRef}
                        handleDuration={handleDuration}
                        allCPs={allCPs}
                        userSessions={userSessions}
                        networkData={networkData}
                      />

                      <div style={{ opacity: isFade ? "0.3" : 1 }}>
                        {dataList.length > 0 && currentFilters && (
                          <>
                            {/* Summary bar */}
                            <div
                              className="row mb-10 ml-5 mr-5"
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                flexWrap: "wrap",
                              }}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "10px",
                                  flexWrap: "wrap",
                                }}
                              >
                                <span
                                  style={{
                                    backgroundColor:
                                      typeBadgeColor[responseType] || "#6c757d",
                                    color: "#fff",
                                    padding: "3px 10px",
                                    borderRadius: "12px",
                                    fontSize: "12px",
                                    textTransform: "capitalize",
                                    fontWeight: "600",
                                  }}
                                >
                                  {responseType}
                                </span>
                                <span
                                  style={{
                                    fontSize: "14px",
                                    color: "#555",
                                    marginBottom: 10,
                                  }}
                                >
                                  Total:{" "}
                                  <strong>{totalCount.toLocaleString()}</strong>{" "}
                                  across <strong>{dataList.length}</strong>{" "}
                                  {responseType === "daily"
                                    ? "days"
                                    : responseType === "weekly"
                                      ? "weeks"
                                      : "months"}
                                </span>
                              </div>

                              <button
                                className="btn btn-info mb-2"
                                onClick={exportToCSV}
                                title="Export to CSV"
                              >
                                <i className="fa fa-file-text-o mr-2"></i>
                                Export CSV
                              </button>
                            </div>

                            <DataTable
                              className="unsub_datatable users"
                              title=""
                              columns={columns}
                              data={dataList}
                              highlightOnHover
                              pagination
                              paginationPerPage={20}
                              paginationRowsPerPageOptions={[20, 50, 100]}
                            />
                          </>
                        )}

                        {!dataList.length && !isLoading && (
                          <div
                            className="mt-20 ml-10"
                            style={{ color: "#888", fontSize: "14px" }}
                          >
                            Please use the filter above to load subscriber
                            counts.
                          </div>
                        )}

                        {isLoading && <LoadingSpinner />}
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
            <Footers />
          </div>
        </div>
      </div>
    </>
  );
}
